import { render, staticRenderFns } from "./CategoryResultSection.vue?vue&type=template&id=08ec0884&scoped=true&"
import script from "./CategoryResultSection.vue?vue&type=script&lang=js&"
export * from "./CategoryResultSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec0884",
  null
  
)

export default component.exports